<template>
  <label :class="borderColor" class="relative h-12 border-b-2 md:h-16">
    <div
      :class="
        labelColor +
          ' ' +
          (value.length || focused
            ? 'left-0 top-0 text-xs leading-4 font-bold'
            : 'left-2 bottom-2 !top-5 text-sm leading-5 font-normal md:bottom-4 !md:top-6 md:leading-6')
      "
      class="absolute flex items-center"
      style="transition: ease 0.2s all;"
    >
      <span>{{ label }}</span>
      <IconDone
        title="success"
        :class="value.length || focused ? 'h-4 w-4' : 'h-4  w-4 md:h-6 md:w-6'"
        class="ml-1"
        v-if="state === 'success'"
      />
      <IconCross
        title="error"
        :class="value.length || focused ? 'h-4 w-4' : 'h-4  w-4 md:h-6 md:w-6'"
        class="ml-1"
        v-if="state === 'error'"
      />
    </div>
    <input
      :class="
        (value.length || focused ? '' : 'placeholder-transparent') +
          ' ' +
          (state === 'disabled'
            ? 'text-AkGreyscaleMediumLtGrey'
            : 'text-AkGreyscaleBlack')
      "
      class="block pt-5 pr-auto pb-2 pl-2 w-full bg-transparent text-sm leading-5 font-normal md:pt-6 md:pb-4 md:leading-6"
      type="text"
      :value="value"
      :placeholder="placeholder"
      :disabled="state === 'disabled'"
      v-bind="$attrs"
      @focus="focused = true"
      @blur="focused = false"
      v-on="inputListeners"
    />
  </label>
</template>

<script>
import IconDone from './icons/IconDone.vue'
import IconCross from './icons/IconCross.vue'

export default {
  name: 'InputField',
  components: { IconDone, IconCross },
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'placeholder'
    },
    state: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    inputListeners: function () {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.value.trim())
        }
      }
    },
    borderColor: function () {
      const { state, focused } = this
      let color = 'border-Ak'

      switch (state) {
        case 'error':
          color += 'MajorCoral'
          break
        case 'success':
          color += 'MainGreen'
          break
        // case 'disabled':
        //   color += 'GreyscaleMediumLtGrey'
        //   break
        default:
          color += focused ? 'MajorTurquoise' : 'GreyscaleLtGrey'
          break
      }
      return color
    },
    labelColor: function () {
      const { value, state, focused } = this
      let color = 'text-Ak'

      switch (state) {
        case 'error':
          color += 'MajorCoral'
          break
        case 'success':
          color += 'MainGreen'
          break
        case 'disabled':
          color += 'GreyscaleMediumLtGrey'
          break
        default:
          color +=
            value.toString().length || focused
              ? 'MajorTurquoise'
              : 'GreyscaleBlack'
          break
      }
      return color
    }
  }
}
</script>
